// src/pages/WebpageShell.js
import React, { useState } from 'react';
import NavigationBar from '../components/HomepageComponents/NavigationBar';
import ContentArea from '../components/HomepageComponents/ContentArea';
import CallToAction from '../components/HomepageComponents/CallToAction';
import Footer from '../components/HomepageComponents/Footer';

/**
 * Reusable shell for any page.
 *
 * Props:
 * - title, subtitle: optional header for ContentArea
 * - showNav, showCTA, showFooter: toggles for sections (default true)
 * - contentPadded: toggle page padding around ContentArea (default true)
 * - navProps: passthrough props for NavigationBar (e.g., isRecPrototypePage, addAnnouncementBar, etc.)
 * - ctaProps: passthrough props for CallToAction (if you later add props)
 * - footerProps: passthrough props for Footer (if you later add props)
 * - className: extra classes on the outermost wrapper
 */
export default function WebpageShell({
  children,
  title,
  subtitle,
  showNav = true,
  showCTA = true,
  showFooter = true,
  contentPadded = true,
  navProps = {},
  ctaProps = {},
  footerProps = {},
  className = '',
}) {
  // Track measured navbar height from NavBar (it supports onHeightChange)
  const [navHeight, setNavHeight] = useState(0);

  return (
   <div className={`w-full mx-auto min-h-screen flex flex-col  bg-white ${className}`}>
      {/* Fixed Nav */}
      {showNav && (
        <NavigationBar
          {...navProps}
          onHeightChange={(h) => setNavHeight(h || 0)}
        />
      )}

      {/* Main content area */}
      <ContentArea title={title} subtitle={subtitle} padded={contentPadded}>
        {children}
      </ContentArea>

      {/* Optional CTA band */}
      {showCTA && (
        <section className="mt-4">
          <CallToAction {...ctaProps} />
        </section>
      )}

      {/* Footer sticks to the bottom if page is short */}
      {showFooter && (
        <div className="mt-auto">
          <Footer {...footerProps} />
        </div>
      )}
    </div>
  );
}
